module.exports = __webpack_public_path__ + "static/media/ic-alipay.ae0a9d87.svg";